import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const FooterSection: React.FC = () => {
  return (
    <Box
      sx={{
        py: 6,
        background: 'linear-gradient(180deg, #0f1a34 0%, #0a1228 100%)',
        borderTop: '1px solid rgba(255,255,255,0.1)',
      }}
    >
      <Container maxWidth="lg">
        {/* 회사 소개 */}
        <Typography
          variant="body1"
          sx={{
            textAlign: 'center',
            color: 'rgba(255,255,255,0.7)',
            mb: 3,
            lineHeight: 1.8,
            '& strong': {
              fontWeight: 700,
              color: 'rgba(255,255,255,0.9)',
            },
          }}
        >
          주식회사 <strong>몰드케어</strong>는 제조업계를 지원하는 다양한 기업과의 연계 사업으로<br />
          소프트웨어, 하드웨어, 솔루션 등 다양한 업무를 지원하고 있습니다.
        </Typography>

        {/* 주소 */}
        <Typography
          variant="body2"
          sx={{
            textAlign: 'center',
            color: 'rgba(255,255,255,0.5)',
            mb: 2,
          }}
        >
          주소: 14119 경기도 안양시 동안구 엘에스로91번길 16-39 안양IT밸리 303호(호계동)
        </Typography>

        {/* Copyright */}
        <Typography
          variant="body2"
          sx={{
            textAlign: 'center',
            color: 'rgba(255,255,255,0.4)',
            '& strong': {
              fontWeight: 700,
              color: 'rgba(255,255,255,0.6)',
            },
          }}
        >
          Copyright © 2025 <strong>몰드케어</strong>, All Rights Reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default FooterSection;
